<template>
  <div class="mapInfo" :style="{ backgroundColor: darkMode ? 'var(--background-color)' : '#FFFFFF' }">
    <h3>{{ store.name }}</h3>
    <div class="storeInfo">
      <div class="line" v-if="!showAddress">
        <a class="action" :href="goToAddress()" target="_blank">
          <p>
            {{ store.address1 }}, {{ store.city }},
            {{ store.state }}
            {{ store.postal_code }}
          </p>
        </a>
      </div>
      <div class="line" v-if="store?.subtitle">
        <a class="action" :href="goToAddress()" target="_blank">
          <p>
          {{store.subtitle}}
          </p>
        </a>
      </div>      
      <div class="line" v-if="!showPhone">
        <a class="action" :href="callPhone()">
          <p>{{ formatPhoneNumber(store.phone) }}</p>
        </a>
      </div>
      <div class="line">
        <p
          :style="{
            color: store.is_open ? 'var(--custom-green-color)' : 'var(--red-color)',
          }"
        >
          {{ store.is_open ? 'Open Now' : 'Closed' }}
        </p>
        <p v-if="store.is_open">
          {{ selectedService.display_name ? selectedService.display_name : selectedService.name }}
          Time: {{ getServiceEstimates(store) }}
        </p>
      </div>
      <button @click="selectStore(store, 'map')" style="margin-top: 20px; width: 100%">
        {{ store.is_open ? 'ORDER NOW' : 'ORDER AHEAD' }}
      </button>
    </div>
  </div>
</template>

<script>
import formattingMixins from '@/mixins/formattingMixins'

import moment from 'moment'

export default {
  props: ['store', 'selectedService', 'darkMode', 'showAddress', 'showPhone'],
  mixins: [formattingMixins],
  methods: {
    callPhone() {
      return `tel:${this.store.phone}`
    },
    goToAddress() {
      return `https://www.google.com/maps/search/?api=1&query=${this.store.address1}, ${this.store.city}, ${this.store.state} ${this.store.postal_code}`
    },
    selectStore(store, from) {
      this.buttonLoader = true
      this.$emit('selectStore', store, from)
    },
    getServiceEstimates(store) {
      let selectedServiceIndex = store.services.findIndex((service) => {
        return service.service_type_id === this.selectedService.service_type_id
      })
      let selectedService = store.services[selectedServiceIndex]
      let estimate = selectedService.lead_time ?? 0 + selectedService.order_time_precision ?? 0
      /*
      If estimate is more than 120 mins, convert to hours with moment.
      This is added because some stores have estimates of 36 hours for catering.
      */
      if (estimate > 120) {
        estimate = moment.duration(estimate, 'minutes').asHours()
        // Round to nearest 0.5
        estimate = Math.round(estimate * 2) / 2
        estimate = estimate + ' hours'
      } else {
        estimate = estimate + ' mins'
      }
      return estimate
    },
  },
}
</script>

<style src="../../assets/css/GoogleMaps/InfoWindowView.css" scoped></style>
